import { render, staticRenderFns } from "./BannerHome.vue?vue&type=template&id=7c53faa2&scoped=true&"
import script from "./BannerHome.vue?vue&type=script&lang=js&"
export * from "./BannerHome.vue?vue&type=script&lang=js&"
import style0 from "./BannerHome.vue?vue&type=style&index=0&id=7c53faa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c53faa2",
  null
  
)

export default component.exports